<template>
    <div>
        <!-- <LocalApplicationModule> -->
        <div>
            <ModuleTitleNav :next-module="nextModule" :previous-module="previousModule" class="title-one">
                {{ moduleTitle }}
            </ModuleTitleNav>
            <div class="section-line" />
            <!-- <fieldset :disabled="formDisabled"> -->
            <fieldset>
                <b-form-row>
                    <b-col>
                        <div class="info-text-section-marker">
                            [Sec 113(b)(2)(B)] &nbsp; & &nbsp; [Sec 113(b)(4)]
                        </div>
                        <p class="info-text">
                            The college shall establish performance targets for
                            each year of the period covered by the Local
                            Application.  Baselines will be based on the
                            average of actual results from the three most
                            recent program years. The state will determine
                            local levels of performance for colleges but
                            provide an opportunity to negotiate should
                            local conditions warrant.
                        </p>
                    </b-col>
                </b-form-row>
                <!-- <div class="dotted-rule"></div> -->
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Targets shall:
                        </div>
                        <ul class="listA">
                            <li>Be expressed in percentage form.</li>
                            <li>Require the college to continually make meaningful progress.</li>
                            <li>
                                Take into account unanticipated circumstance that
                                may have contributed to extraordinarily high or low baselines.
                            </li>
                            <li>Be available to stakeholders for comment and input.</li>
                        </ul>
                    </b-col>
                </b-form-row>
                <div class="section-line" />
                <b-form-row>
                    <b-col>
                        <div class="title-five" style="color: #380064">
                            Core Indicator Definitions
                        </div>
                        <div class="field-labels">
                            1P1: Retention/Placement
                        </div>
                        <p>
                            The percentage of CTE concentrators who, during the second quarter after program completion:
                        </p>
                        <ol type="a" class="listB">
                            <li>Remain enrolled in postsecondary education</li>
                            <li>Are placed or retained in employment</li>
                            <li>Are in advanced training</li>
                            <li>Are in military service</li>
                            <li>
                                Are in a service program that receives assistance
                                under Title I of the National and Community Service Act of 1990
                            </li>
                            <li> Are volunteers as described in section 5(a) of the Peace Corps Act </li>
                        </ol>
                    </b-col>
                </b-form-row>
                <div class="dotted-rule" />
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            2P1-Credential Attainment
                        </div>
                        <p>
                            The percentage of CTE concentrators who receive a recognized
                            postsecondary credential during participation in or within
                            1 year of program completion.
                        </p>
                        <p>
                            The term ‘recognized postsecondary credential’ has the
                            meaning given the term in section 3 of the Workforce
                            Innovation and Opportunity Act (29 U.S.C. 3102).
                        </p>
                        <ol type="a" class="listB">
                            <li>Industry-recognized certificate or certification</li>
                            <li>Certificate of completion of an apprenticeship</li>
                            <li>
                                License recognized by the State or Federal Government
                            </li>
                            <li>
                                Associate degree
                                <br>(TEGL:  DoL Training and Education Guidance Letter)
                                <br>Sec. 3. (43) Definitions)
                                <br>Baccalaureate degree removed by Technical
                                Correction in the Consolidated Appropriations Act of 2019
                            </li>
                        </ol>
                    </b-col>
                </b-form-row>
                <div class="dotted-rule" />
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            3P1-Nontraditional Participation
                        </div>
                        <ol type="a" class="listB">
                            <li>
                                The percentage of CTE concentrators in career and
                                technical education programs and programs of study
                                that lead to non-traditional fields.
                            </li>
                        </ol>
                    </b-col>
                </b-form-row>
                <div class="section-line" />
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Core Indicator Performance Targets
                        </div>

                        <b-table
                            :items="applicationPerkinsPerformance"
                            striped
                            small
                            bordered
                            :fields="coreIndicatorTableFields"
                            :disabled="formDisabled || tableDisabled"
                            @saveForm="saveForm"
                        >
                            <template v-slot:cell(indicatorDisplayName)="data">
                                {{ data.item.indicatorDisplayName }}
                            </template>

                            <template v-slot:cell(baseline)="data">
                                {{ (data.item.baseline + '%') || 'Loading...' }}
                            </template>

                            <template v-slot:cell()="data">
                                <b-input-group append="%">
                                    <b-input
                                        :value="indicatorTargets[data.item.perkinsIndicator]
                                            ? indicatorTargets[data.item.perkinsIndicator][data.field.key]
                                            : data.target"
                                        type="number"
                                        number
                                        :min="0.00"
                                        :max="100.00"
                                        :step="0.01"
                                        :disabled="formDisabled || tableDisabled"
                                        @update="indicatorTargets = {
                                            indicator: data.item.perkinsIndicator,
                                            academicYear: data.field.key,
                                            target: $event
                                        }"
                                        @blur.native="blurCheck"
                                    />
                                </b-input-group>
                            </template>
                        </b-table>
                    </b-col>
                </b-form-row>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Factors influencing targets for 1P1: Retention/Placement
                        </div>
                        <b-form-textarea
                            v-model="factors1P1"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Factors influencing targets for 2P1: Credential Attainment
                        </div>
                        <b-form-textarea
                            v-model="factors2P1"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Factors influencing targets for 3P1: Nontraditional Participation
                        </div>
                        <b-form-textarea
                            v-model="factors3P1"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
                <b-form-row>
                    <b-col>
                        <div class="field-labels">
                            Provide any additional information that should be considered when negotiating core
                            indicator targets.
                        </div>
                        <b-form-textarea
                            v-model="additionalInformation"
                            :disabled="formDisabled"
                            :rows="3"
                        />
                    </b-col>
                </b-form-row>
                <br>
            </fieldset>
        </div>
        <!-- <div class="dotted-rule"></div> -->
        <div>
            <b-form-row>
                <b-col>
                    <LocalApplicationModuleActions
                        :is-loading="isSaving"
                        background-color="#006438"
                        :is-disabled="formDisabled"
                        @saveForm="saveForm"
                    />
                </b-col>
            </b-form-row>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import { Log } from '$Shared/@arc/vue-arc';
// import LocalApplicationModule from '$Components/LocalApplicationModule';

const storeModuleName = 'baselineAndTargets';
// const storeModuleNamespace = 'localApplications/module';

export default {
    name: 'BaselineAndTargets',

    // components: {
    //     LocalApplicationModule,
    // },

    props: {
        // formDisabled: { type: Boolean, default: true },
    },

    data() {
        return {
            isSaving: false,
            moduleTitle: 'Baseline and Targets',
            nextModule: { name: 'localApplication.ImprovementPlan' },
            // previousModule: { name: 'localApplication.AdministrativeFunds' },
            previousModule: { name: 'localApplication.Section113Instructions' },
        };
    },

    computed: {
        ...mapState('ref/perkinsIndicators', {
            perkinsIndicatorPerformance: 'perkinsPerformanceWithIndicatorDetails',
        }),

        ...mapState('localApplication', {
            currentState: (state) => state.localApplicationData.state.currentState,
            applicantId: (state) => state.localApplicationData.applicantId,
            localApplicationAy: (state) => state.localApplicationData.academicYear,
        }),

        ...mapGetters({
            isAuthorized: 'auth/isAuthorized',
            isReviewer: 'auth/isReviewer',
            targetsWindow: 'ref/perkinsIndicators/fourYearAyTargetsWindow',
            localApplicationModuleContent: `localApplication/module/${storeModuleName}/content`,
        }),

        // dynamically build out the Baseline and Targets table headers based on the current AY window
        coreIndicatorTableFields() {
            const targetAys = this.targetsWindow(this.localApplicationAy);

            let tbl = [
                { key: 'indicatorDisplayName', label: 'Core Indicator' },
                { key: 'baseline', label: 'Baseline' },
            ];

            targetAys.map((v) => {
                tbl.push({ key: `ay${v}`, label: `20${v - 1}-${v}` });
            });

            return tbl;
        },

        formDisabled() {
            return !this.isAuthorized('update', 'local_application', this.currentState);
        },

        tableDisabled() {
            let disable = false;
            let ay = Number(this.localApplicationAy);
            if (ay >= 22) {
                disable = true;
            }
            return disable;
        },

        applicationPerkinsPerformance() {
            if (this.isReviewer) {
                return this.perkinsIndicatorPerformance.filter((indicator) => {
                    return indicator.applicantId === this.applicantId;
                });
            }

            return this.perkinsIndicatorPerformance;
        },

        indicatorTargets: {
            get() { return this.localApplicationModuleContent.indicatorTargets; },
            set(v) { this.updateIndicatorTarget(v); }
        },

        factors1P1: {
            get() { return this.localApplicationModuleContent.factors1P1; },
            set(v) { this.updateFactors1P1(v); }
        },

        factors2P1: {
            get() { return this.localApplicationModuleContent.factors2P1; },
            set(v) { this.updateFactors2P1(v); }
        },

        factors3P1: {
            get() { return this.localApplicationModuleContent.factors3P1; },
            set(v) { this.updateFactors3P1(v); }
        },

        additionalInformation: {
            get() { return this.localApplicationModuleContent.additionalInformation; },
            set(v) { this.updateAdditionalInformation(v); }
        }
    },

    methods: {
        ...mapActions(`localApplication/module/${storeModuleName}/`, {
            saveLocalApplicationModule: 'save',
            updateIndicatorTarget: 'updateIndicatorTarget',
            updateFactors1P1: 'updateFactors1P1',
            updateFactors2P1: 'updateFactors2P1',
            updateFactors3P1: 'updateFactors3P1',
            updateAdditionalInformation: 'updateAdditionalInformation',
        }),

        blurCheck($event) {
            // TODO: Rudimentary validation for percentages on idicator targets. Extract to vee-validate etc.
            // TODO: Move to store, if possible
            // TODO: Fetching/mapping validation from API might be a better approach
            $event.target.reportValidity();
        },

        async saveForm() {
            this.isSaving = true;
            try {
                const response = await this.saveLocalApplicationModule();
                this.isSaving = false;
                Log.debug(response, `COMPONENT:${this.name} -> Save module response:`);
            } catch (error) {
                console.log(error);
                this.isSaving = false;
            }
        },
    },
};
</script>
